<template lang="pug">
el-input.filter-search(v-model='inner_value', :placeholder='placeholder', icon='close', :on-icon-click='clear', auto-complete='on')
</template>

<script>
import _ from 'lodash'
import Fuse from 'fuse.js'
import DeepValue from './deep_value'
import AutoMixin from '../auto/mixin'

export default {
  name: 'filter-search',
  props: {
    filter: { type: Object, required: true },
    value: String,
    placeholder: String,
    preset: { type: String, default: 'default' },
    defines: null,
  },
  mixins: [AutoMixin],
  computed: {
    fuse_options() {
      let extend = {}
      extend = this.filter || {}

      const getFn = (obj, path) => {
        if (path.startsWith('#')) {
          const key = path.slice(1)
          return [`${obj[key]}`]
        } else if (path.startsWith('$')) {
          // Use formattered value for filed starts with '$'
          const key = path.slice(1)
          const prop = this.prop(key)
          if (prop && prop.$value)
            return [prop.$value(obj)]
        }
        // Otherwise use the default get
        return DeepValue(obj, path)
      }

      return {
        location: 0,
        distance: 100,
        threshold: 0.2,
        keys: [],
        shouldSort: true,
        getFn,
        ...extend,
      }
    },
  },
  mounted() {
    this.inner_value = this.value
  },
  data() {
    return {
      inner_value: '',
      inner_result: null,
    }
  },
  watch: {
    value() {
      this.inner_value = this.value
    },
    inner_value() {
      this.emit()
    },
  },
  methods: {
    clear() {
      this.inner_value = ''
    },
    $filter(data) {
      if (!this.inner_value)
        return data

      const fuse = new Fuse(data, this.fuse_options)
      return fuse.search(this.inner_value || '')
    },
    emit: _.debounce(function () {
      this.$emit('input', this.inner_value)
      this.$emit('filter')
    }, 1000),
  },
}
</script>



// WEBPACK FOOTER //
// FilterSearch.vue?0298304d